import { MdAreaChart } from "react-icons/md";

const getDataFieldsArea = () => {
  return [
    {
      title: "X-Axis",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Metrics",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Dimension",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 500,
      valueType: "Number",
      canEdit: true,
    },
  ];
};

const getCustomizationFieldArea = () => {
  return [
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },

    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isLabelVisible",
      innerComponents: [
        {
          title: "Position",
          type: "SELECT_BOX",
          reduxKey: "labelPosition",
          options: [
            { label: "Top", value: "top" },
            { label: "Bottom", value: "bottom" },
            { label: "Center", value: "center" },
          ],
          defaultValue: { label: "Top", value: "top" },
          isParent: true,
        },
        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "labelFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Font Size",
          type: "range",
          defaultValue: 9,
          minValue: 10,
          maxValue: 40,
          reduxKey: "labelFontSize",
          isParent: true,
        },
        {
          title: "Rotate",
          type: "range",
          defaultValue: 0,
          minValue: 0,
          maxValue: 360,
          reduxKey: "labelRotate",
          isParent: true,
        },
      ],
    },
    {
      title: "LineType",
      type: "SELECT_BOX",
      reduxKey: "lineTypes",
      options: [
        { label: "Monotone", value: "monotone" },
        { label: "Linear ", value: "linear " },
        { label: "Step", value: "step" },
        { label: "linearClosed", value: "linearClosed" },
      ],
      defaultValue: { label: "Monotone ", value: "monotone" },
      isParent: true,
    },

    // {
    //   title: "Color",
    //   type: "COLOR",
    //   reduxKey: "colorSchemeid",
    //   defaultType: "RANDOM",
    // },
    {
      title: "Line Size",
      type: "range",
      defaultValue: 2,
      minValue: 1,
      maxValue: 10,
      reduxKey: "lineSize",
    },
    // transparent
    {
      title: "Transparent",
      type: "range",
      defaultValue: 20,
      minValue: 10,
      maxValue: 90,
      reduxKey: "transparentColor",
    },

    {
      title: "PercentAreaChart",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isStackbarVisible",
    },
    //axes label
    {
      title: "Axes label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isAxeslabelVisible",
      innerComponents: [
        {
          title: "Font Size",
          type: "range",
          defaultValue: 21,
          minValue: 20,
          maxValue: 40,
          reduxKey: "labelAxesFontSize",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "labelAxesFontColor",
          defaultValue: "#878787",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },

    //legend
    {
      title: "Legend",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isLegendVisible",
      innerComponents: [
        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "legendFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: false,
          reduxKey: "isLegendBold",
          isParent: true,
        },
        {
          title: "Align",
          type: "SELECT_BOX",
          reduxKey: "legendAlign",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
          defaultValue: { label: "Center", value: "center" },
          isParent: true,
        },
        {
          title: "Vertical Align",
          type: "SELECT_BOX",
          reduxKey: "legendVerticalAlign",
          options: [
            { label: "Top", value: "top" },

            { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Bottom", value: "top" },
          isParent: true,
        },
        {
          title: "Layout",
          type: "SELECT_BOX",
          reduxKey: "legendLayout",
          options: [
            { label: "Horizontal", value: "horizontal" },
            { label: "Vertical", value: "vertical" },
          ],
          defaultValue: { label: "Horizontal", value: "horizontal" },
          isParent: true,
        },
      ],
    },
    //textbox
    {
      title: "Title",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isTileVisible",
      innerComponents: [
        {
          title: "Title",
          type: "text",
          defaultValue: "title...",
          minValue: 0,
          maxValue: 20,
          reduxKey: "Title",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Bold",
          type: "checkbox",
          defaultValue: false,
          reduxKey: "isTitleBold",
          isParent: true,
        },
        {
          title: "Title Color",
          type: "fontColor",
          reduxKey: "TitleFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
          defaultValue: "#bababa",
        },
        {
          title: "Title Size",
          type: "range",
          defaultValue: 25,
          minValue: 8,
          maxValue: 30,
          reduxKey: "TitleSize",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },

        {
          title: "Value Align",
          type: "textAlign",
          reduxKey: "valueAlign",
          defaultValue: "center",
        },



      ],
    },

  ];
};
const getAreaChartDetails = () => {
  return {
    chartType: "recharts",
    imageSrc: "/graph_img/Areachart.png",
    label: "Area",
    value: "areachart",
    icon: <MdAreaChart className="text-xl text-blue-950" />,
    fileName: "AreaChartComp.js",
  };
};
export { getDataFieldsArea, getCustomizationFieldArea, getAreaChartDetails };
